module.exports = {"id":"183427","name":"Fabian Delph","rating":"79","photo":"./data/images/photos/1/183427.png","club":{"name":"Manchester City","logo":"./data/images/clubs/ManchesterCity.png"},"positions":["DG","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabianDelph0.json
// module id = 1326
// module chunks = 0